import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateOrderFormField, clearOrderFormError } from '../../redux_files/actions/orderFormActions';
import { THEME } from '../../utils/theme';

const QuantityStep = () => {
  const dispatch = useDispatch();
  const { selectedDate, mealType, plateSize, numberOfPlates, errors } = useSelector(state => state.orderForm);
  
  // Styles object
  const styles = {
    selectedDateDisplay: {
      marginBottom: '20px'
    },
    summaryRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    summaryRowWithMargin: {
      marginTop: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    infoMessage: {
      marginTop: '10px',
      padding: '10px',
      backgroundColor: THEME.warning.light,
      borderLeft: `4px solid ${THEME.warning.main}`,
      borderRadius: '4px',
      color: THEME.warning.dark,
      fontSize: '13px'
    }
  };
  
  const handleNumberChange = (e) => {
    const value = e.target.value;
    if (value === '') {
      dispatch(updateOrderFormField('numberOfPlates', ''));
    } else {
      const numValue = parseInt(value);
      if (!isNaN(numValue) && numValue >= 0) {
        dispatch(updateOrderFormField('numberOfPlates', numValue));
      }
    }
    dispatch(clearOrderFormError('plate'));
  };

  const handleIncrement = () => {
    const currentValue = numberOfPlates === '' ? 0 : numberOfPlates;
    dispatch(updateOrderFormField('numberOfPlates', currentValue + 1));
  };

  const handleDecrement = () => {
    const currentValue = numberOfPlates === '' ? 0 : numberOfPlates;
    if (currentValue > 0) {
      dispatch(updateOrderFormField('numberOfPlates', currentValue - 1));
    }
  };
  return (
    <>
      {/* Selection Summary */}
      <div className='selected-date-display' style={styles.selectedDateDisplay}>
        <div style={styles.summaryRow}>
          <span>Delivery Date:</span>
          <strong>{new Date(selectedDate).toLocaleDateString('en-IN', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}</strong>
        </div>
        <div style={styles.summaryRowWithMargin}>
          <span>Meal Type:</span>
          <strong>{mealType ? mealType.charAt(0).toUpperCase() + mealType.slice(1) : 'N/A'}</strong>
        </div>
        <div style={styles.summaryRowWithMargin}>
          <span>Plate Type:</span>
          <strong>{plateSize === 'full' ? 'Full Plate' : 'Buffet'}</strong>
        </div>
      </div>

      <h3 className='quantity-label'>No of Plates</h3>
      <div className='plates-input-section'>
        <button className='quantity-btn minus-btn' onClick={handleDecrement}>−</button>
        <input
          type='number'
          min='0'
          value={numberOfPlates}
          onChange={handleNumberChange}
          className='plates-input'
          placeholder='0'
        />
        <button className='quantity-btn plus-btn' onClick={handleIncrement}>+</button>
      </div>
      {(numberOfPlates === 0 || numberOfPlates === '') && (
        <div style={styles.infoMessage}>
          ℹ️ Please order at least 1 plate to continue
        </div>
      )}
      {errors.plate && (
        <div className='error-message'>{errors.plate}</div>
      )}
    </>
  );
};

export default QuantityStep;
